import { 
        apiResultSuccess, 
        getBoardSettings, 
        getBoardTypes, 
        orderBoards, 
        updateBoardVisibility 
} from "../apihelper";

import { SettingSubject } from "../components/Subject";

export default class BoardSettingsController {

    constructor(data={}, contents=[], boards=[], boardTypes=[]) {
        this.data = data;
        this.contents = contents;   
        this.boards = boards;
        this.boardTypes = boardTypes;
        this.subject = new SettingSubject();
    }


    fetchData() {

        getBoardTypes(
            (results) => {
                if ( apiResultSuccess(results) ) {
                    if ( results.types ) {
                        this.boardTypes = results.types;
                    }
                }
            }
        );

        getBoardSettings(
            (results) => {
                if ( apiResultSuccess(results) ) {
                    if ( results.boards ) {
                        this.boards = results.boards;
                    }
                }
            }
        );

    }

    updateBoardsOrder(boardIds=[]) {
        const postData = { board_ids: boardIds };
        orderBoards(
            (result) => {
                if ( apiResultSuccess(result) ) {
                    // notify

                    this.subject.boardOrderChange();

                    // window.location.reload();
                }
            }, 
            postData
        );
    }
    
    toggleBoardVisibility(hidden=false, boardId=-1, type='') {
        const postData =  { board_id: boardId, hidden: hidden };
            
        updateBoardVisibility(
            (result) => {
                if ( apiResultSuccess(result) ) {
                    this.subject.boardVisibilityChange( hidden, { id: boardId, type: type } );
                }
            },
            postData
        );
    }

    newBoardSuccess() {
        this.subject.boardCreation();
    }

    editBoardSuccess(boardDetails) {
        this.subject.boardEdit(boardDetails);
    }

    addObserver(observer=false) {
        if ( observer ) {
            this.subject.addObserver(observer);
        }
    }
}